<template>
  <div>
    <b-card>
      <b-row>
        <!-- User Info: Left col -->
        <b-col
          cols="21"
          xl="6"
          class="d-flex justify-content-between flex-column"
        >
          <!-- User Avatar & Action Buttons -->
          <div class="d-flex justify-content-start">
            <b-avatar
              :src="userData.thumbnailUrl"
              :text="avatarText(userData.fullName)"
              :variant="`light-${resolveUserRoleVariant(userData.role)}`"
              size="104px"
              rounded
            />
            <div class="d-flex flex-column ml-1">
              <div class="mb-1">
                <h4 class="mb-0">
                  {{ userData.shopName }}
                </h4>
                <span class="card-text">{{ userData.email }}</span>
              </div>
              <div class="d-flex flex-wrap">
                <b-button
                  v-b-modal.modal-seller-status
                  variant="outline-primary"
                >
                  แก้ไข
                </b-button>

                <!-- <b-button variant="outline-danger" class="ml-1">
                Delete
              </b-button> -->
              </div>
            </div>
          </div>

          <!-- User Stats -->
          <div class="d-flex align-items-center mt-2">
            <div class="d-flex align-items-center mr-2">
              <b-avatar variant="light-primary" rounded>
                <feather-icon icon="DollarSignIcon" size="18" />
              </b-avatar>
              <div class="ml-1">
                <h5 class="mb-0">{{ userData.finance.totalRevenue }} บาท</h5>
                <small>ยอดขายทั้งหมด</small>
              </div>
            </div>

            <div class="d-flex align-items-center">
              <b-avatar variant="light-success" rounded>
                <feather-icon icon="TrendingUpIcon" size="18" />
              </b-avatar>
              <div class="ml-1">
                <h5 class="mb-0">{{ userData.finance.withdrawal }} บาท</h5>
                <small>ยอดการถอนเงิน</small>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <b-avatar variant="light-success" rounded>
                <feather-icon icon="TrendingUpIcon" size="18" />
              </b-avatar>
              <div class="ml-1">
                <h5 class="mb-0">{{ userData.finance.refund }} บาท</h5>
                <small>ยอดการคืนเงิน</small>
              </div>
            </div>
          </div>
        </b-col>

        <!-- Right Col: Table -->
        <!-- <b-col cols="12" xl="6">
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">Username :</span>
            </th>
            <td class="pb-50">
              {{ userData.username }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="CheckIcon" class="mr-75" />
              <span class="font-weight-bold">Password :</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.status }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="StarIcon" class="mr-75" />
              <span class="font-weight-bold">ชื่อ :</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.role }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="FlagIcon" class="mr-75" />
              <span class="font-weight-bold">นามสกุล :</span>
            </th>
            <td class="pb-50">
              {{ userData.country }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="PhoneIcon" class="mr-75" />
              <span class="font-weight-bold">เพศ :</span>
            </th>
            <td class="pb-50">
              {{ userData.contact }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="PhoneIcon" class="mr-75" />
              <span class="font-weight-bold">วัน/ เดือน/ ปี/ เกิด :</span>
            </th>
            <td>
              {{ userData.contact }}
            </td>
          </tr>
        </table>
      </b-col> -->
      </b-row>
    </b-card>
    <b-modal
      id="modal-seller-status"
      centered
      title="แก้ไข"
      ok-only
      ok-title="บันทึก"
      @ok="handlerDelete"
      ref="modal-shop"
    >
      <b-form-group  label="Commission Rate(%)"
          label-for="commission_rate"
          label-cols-md="4">
        <b-form-input trim id="commission_rate" v-model=" commistion"/>
      </b-form-group>
      <b-form-group   label="สถานะการใช้งาน"
          label-for="status"
          label-cols-md="4">
        <v-select
        id="status"
          v-model="selected"
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          label="title"
          :options="option"
        />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol,BFormInput,  BFormGroup } from "bootstrap-vue";
import { avatarText } from "@core/utils/filter";
import useUsersList from "../members-list/useMembersList";
import vSelect from "vue-select";
import store from "@/store";
import { ref, onUnmounted } from "@vue/composition-api";
import router from "@/router";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
    BFormGroup,
    vSelect,
    BFormInput, 
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    
      option: [{ title: "ใช้งาน" }, { title: "ไม่ใช้งาน" }],
    };
  },
  setup(props) {
    console.log('chec', props)
    const { resolveUserRoleVariant } = useUsersList();
    const selected = ref(null)
    const commistion = ref("")
    const userData = props.userData
    if(userData.status) {
      selected.value = { title: "ใช้งาน"}
    } else {
      selected.value = { title: "ไม่ใช้งาน"}
    }
    commistion.value = userData.commissionLate
    return {
      avatarText,
      resolveUserRoleVariant,
      selected,
      commistion
    };
  },
  mounted() {
    if (router.currentRoute.params.isEdit == true) {
      this.$refs["modal-shop"].show();
    }
  },
  methods: {
    handlerDelete() {
      if (this.selected.title == "ไม่ใช้งาน") {
        store
          .dispatch("seller/deleteShop", {
            id: this.userData.shopId,
            status: false,
            commistion: this.commistion
          })
          .then((response) => {
            console.log("data", response);
          })
          .catch((error) => {
            console.log("err", error);
          });
      } else {
        store
          .dispatch("seller/deleteShop", {
            id: this.userData.shopId,
            status: true,
            commistion: this.commistion
          })
          .then((response) => {
            console.log("data", response);
          })
          .catch((error) => {
            console.log("err", error);
          });
      }
    },
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
